import { FlowScreen } from "../../../models/AtticusScreenFlow";
import { User } from "../../../models/User";
import { Estate } from "../../../models/Estate";
import { AboutYouScreen } from "./AboutYouScreen";
import { OUTCOMES } from "../../../constants";
import { AboutYouNameScreen } from "./AboutYouNameScreen";
import { AboutYouAddress } from "./AboutYouAddress";
import { AboutYouPhone } from "./AboutYouPhone";
import { UploadGovernmentIDScreen } from "./UploadGovernmentIDScreen";
import { AboutTheEstateScreen } from "./AboutTheEstateScreen";
import { ApplicationSubmittedScreen } from "./ApplicationSubmittedScreen";
import { UploadFileScreen } from "./UploadFileScreen";
import { ExecutorVerificationSteps } from ".";

export type FlowData = {
  user?: User;
  estate?: Estate;
};

export enum Sections {
  AboutYou = "About You",
  AboutTheEstate = "About the Estate",
  GetVerified = "Get Verified",
}
export enum Screens {
  AboutYou = "About You",
  BasicInfoFullName = "Full Name",
  BasicInfoAddress = "Address",
  BasicInfoPhoneNumber = "Phone Number",
  PhotoVerification = "Photo Verification",
  GovtIssuedID = "Government Issued I.D.",
  AboutTheEstate = "About the estate",
  DeathCertificate = "Death Certificate",
  CopyOfWill = "Copy of Will",
  LettersOrAgreement = "Letters or Agreement",
  ApplicationSubmittedScreen = "Application Submitted",
}

export enum ExecutorVerificationOutcomes {
  StartAboutYouSubFlow = "StartAboutYouSubFlow",
  StartPhotoVerificationSubFlow = "StartPhotoVerificationSubFlow",
  StartGovernmentIDSubFlow = "StartGovernmentIDSubFlow",
  StartDeathCertificateSubFlow = "StartDeathCertificateSubFlow",
  StartCopyOfWillSubFlow = "StartCopyOfWillSubFlow",
  StartLettersOrAgreementSubFlow = "StartLettersOrAgreementSubFlow",
}

export const screenFlow: FlowScreen[] = [
  {
    name: Screens.AboutYou,
    screenComponent: <AboutYouScreen />,
    pathSuffix: "about-you",
    section: Sections.AboutYou,
    next: [
      {
        outcome: ExecutorVerificationOutcomes.StartAboutYouSubFlow,
        screen: Screens.BasicInfoFullName,
      },
      {
        outcome: ExecutorVerificationOutcomes.StartPhotoVerificationSubFlow,
        screen: Screens.PhotoVerification,
      },
      {
        outcome: ExecutorVerificationOutcomes.StartGovernmentIDSubFlow,
        screen: Screens.GovtIssuedID,
      },
      {
        outcome: OUTCOMES.complete,
        screen: Screens.AboutTheEstate,
      },
    ],
    first: true,
  },
  {
    name: Screens.PhotoVerification,
    section: Sections.AboutYou,
    pathSuffix: "photo-verification",
    screenComponent: <UploadFileScreen variant={ExecutorVerificationSteps.EXECUTOR_VERIFICATION_STEP_PHOTO_VERIFIATION_ID} />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutYou },
      { outcome: OUTCOMES.back, screen: Screens.AboutYou },
    ],
  },
  {
    name: Screens.BasicInfoFullName,
    section: Sections.AboutYou,
    pathSuffix: "full-name",
    screenComponent: <AboutYouNameScreen />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.BasicInfoAddress },
      { outcome: OUTCOMES.back, screen: Screens.AboutYou },
    ],
  },
  {
    name: Screens.BasicInfoAddress,
    section: Sections.AboutYou,
    pathSuffix: "address",
    screenComponent: <AboutYouAddress />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.BasicInfoPhoneNumber },
      { outcome: OUTCOMES.back, screen: Screens.BasicInfoFullName },
    ],
  },
  {
    name: Screens.BasicInfoPhoneNumber,
    section: Sections.AboutYou,
    pathSuffix: "phone",
    screenComponent: <AboutYouPhone />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutYou },
      { outcome: OUTCOMES.back, screen: Screens.BasicInfoAddress },
    ],
  },
  {
    name: Screens.GovtIssuedID,
    section: Sections.AboutYou,
    pathSuffix: "govt-approved-id",
    screenComponent: <UploadGovernmentIDScreen />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutYou },
      { outcome: OUTCOMES.back, screen: Screens.AboutYou },
    ],
  },
  {
    name: Screens.AboutTheEstate,
    section: Sections.AboutTheEstate,
    pathSuffix: "about-the-estate",
    screenComponent: <AboutTheEstateScreen />,
    next: [
      {
        outcome: ExecutorVerificationOutcomes.StartDeathCertificateSubFlow,
        screen: Screens.DeathCertificate,
      },
      {
        outcome: ExecutorVerificationOutcomes.StartCopyOfWillSubFlow,
        screen: Screens.CopyOfWill,
      },
      {
        outcome: ExecutorVerificationOutcomes.StartLettersOrAgreementSubFlow,
        screen: Screens.LettersOrAgreement,
      },
      {
        outcome: OUTCOMES.complete,
        screen: Screens.ApplicationSubmittedScreen,
      },
    ],
  },
  {
    name: Screens.DeathCertificate,
    section: Sections.AboutTheEstate,
    pathSuffix: "death-certificate",
    screenComponent: <UploadFileScreen variant={ExecutorVerificationSteps.EXECUTOR_VERIFICATION_STEP_DEATH_CERTIFICATE} />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutTheEstate },
      { outcome: OUTCOMES.back, screen: Screens.AboutTheEstate },
    ],
  },
  {
    name: Screens.CopyOfWill,
    section: Sections.AboutTheEstate,
    pathSuffix: "copy-of-will",
    screenComponent: <UploadFileScreen variant={ExecutorVerificationSteps.EXECUTOR_VERIFICATION_STEP_WILL} />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutTheEstate },
      { outcome: OUTCOMES.back, screen: Screens.AboutTheEstate },
    ],
  },
  {
    name: Screens.LettersOrAgreement,
    section: Sections.AboutTheEstate,
    pathSuffix: "letters-or-agreement",
    screenComponent: <UploadFileScreen variant={ExecutorVerificationSteps.EXECUTOR_VERIFICATION_STEP_LETTERS_OR_AGREEMENT} />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutTheEstate },
      { outcome: OUTCOMES.back, screen: Screens.AboutTheEstate },
    ],
  },
  {
    name: Screens.ApplicationSubmittedScreen,
    section: Sections.GetVerified,
    pathSuffix: "application-submitted",
    screenComponent: <ApplicationSubmittedScreen />,
    next: [
      { outcome: OUTCOMES.complete, screen: Screens.AboutTheEstate },
      { outcome: OUTCOMES.back, screen: Screens.AboutTheEstate },
    ],
  },
];
